var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import classnames from "classnames";
import { E, ToJSON } from "js-vextensions";
import { runInAction } from "mobx";
import { Fragment } from "react";
import { Droppable } from "react-beautiful-dnd";
import { Button, Column, Pre, Row, TextInput } from "react-vcomponents";
import { BaseComponent, BaseComponentPlus, ClassBasedStyles, GetDOM } from "react-vextensions";
import { ShowMessageBox } from "react-vmessagebox";
import { ScrollView } from "react-vscrollview";
import { AddBookEvent } from "Server/Commands/AddBookEvent";
import { SetBookEventIndex } from "Server/Commands/SetBookEventIndex";
import { store } from "Store";
import { GetCharacterEvents, GetEventIndexes, GetEvents, GetOrderedEvents, GetSelectedEvent, GetUnorderedEvents } from "Store/firebase/events";
import { DroppableInfo } from "Utils/UI/DNDStructures";
import { InfoButton, Observer, PageContainer, RunInAction_Set } from "vwebapp-framework";
import { GetCharacters, GetSelectedCharacter } from "../../Store/firebase/characters";
import { BookEvent } from "../../Store/firebase/events/@BookEvent";
import { EventDetailsPanel } from "./Events/EventDetailsPanel";
import { EventRow } from "./Events/EventRow";
let PanelToggleButton = class PanelToggleButton extends BaseComponentPlus({}, {}) {
    render() {
        const { panel, title } = this.props;
        const panelsVisible = store.main.write.events_panelsVisible;
        const isVisible = panelsVisible.Contains(panel);
        return (React.createElement(Button, { text: title, style: E(isVisible && { fontWeight: "bold" }), onClick: () => {
                const newPanelsVisible = isVisible ? panelsVisible.Except(panel) : panelsVisible.concat([panel]);
                RunInAction_Set(this, () => store.main.write.events_panelsVisible = newPanelsVisible);
            } }));
    }
};
PanelToggleButton = __decorate([
    Observer
], PanelToggleButton);
let EventsUI = class EventsUI extends BaseComponentPlus({}, {}) {
    render() {
        const { bookID } = this.props;
        const characters = GetCharacters(bookID);
        const selectedCharacter = GetSelectedCharacter(bookID);
        const events = GetEvents(bookID);
        const selectedEventID = store.main.write.selectedEvent;
        const selectedEvent = GetSelectedEvent();
        const panelsVisible = store.main.write.events_panelsVisible;
        if (bookID == null)
            return React.createElement("div", null, "Please select a book.");
        const characters_ordered = characters.OrderBy(a => a.level);
        return (React.createElement(PageContainer, { preset: "full" /*scrollable={true}*/, innerStyle: { flexDirection: "row", padding: 10, alignItems: "flex-start" } },
            React.createElement("div", { style: { width: 40 } },
                React.createElement(Row, { style: { width: 500, transformOrigin: "bottom left", transform: "rotate(90deg)" } },
                    React.createElement(PanelToggleButton, { panel: "characters", title: "Characters" }),
                    React.createElement(PanelToggleButton, { panel: "unordered", title: "Unordered" }),
                    React.createElement(PanelToggleButton, { panel: "ordered", title: "Ordered" }),
                    React.createElement(PanelToggleButton, { panel: "event details", title: "Event details" }))),
            panelsVisible.Contains("characters") &&
                React.createElement(Column, { className: "clickThrough", style: { flex: 12.5, height: "100%", background: "rgba(0,0,0,.7)", borderRadius: 10 } },
                    React.createElement(Row, { style: { height: 40, padding: 10 } },
                        React.createElement(Pre, null, "Characters"),
                        React.createElement(InfoButton, { ml: 5, text: `
								The three numbers shown are unordered-event-count, placeholder-count, and ordered-event-count.
								
								The percent number equals: ordered-event-count / (ordered-event-count + placeholder-count) [however, this number only considers events up to the specified target-week-completion]
							`.AsMultiline(0) })),
                    React.createElement(ScrollView, null, characters_ordered.map((char, index) => {
                        const differentLevelThanLastChar = index == 0 || characters_ordered[index - 1].level != char.level;
                        return React.createElement(CharEntryUI, { key: char._key, character: char, selected: selectedCharacter == char, differentLevel: differentLevelThanLastChar });
                    }))),
            panelsVisible.Contains("unordered") && selectedCharacter && React.createElement(UnorderedEventColumn, { bookID: bookID, character: selectedCharacter }),
            panelsVisible.Contains("ordered") && selectedCharacter && React.createElement(OrderedEventColumn, { bookID: bookID, character: selectedCharacter }),
            panelsVisible.Contains("event details") && selectedCharacter && selectedEventID && React.createElement(EventDetailsPanel, { event: selectedEvent, character: selectedCharacter })));
    }
};
EventsUI = __decorate([
    Observer
], EventsUI);
export { EventsUI };
let CharEntryUI = class CharEntryUI extends BaseComponentPlus({}, {}) {
    render() {
        const { character, selected, differentLevel } = this.props;
        const events = GetCharacterEvents(character.book, character._key);
        const orderedEvents = GetOrderedEvents(character.book, character._key, true);
        const unorderedEvents = GetUnorderedEvents(character.book, character._key);
        const targetWeekCompletion = store.main.write.targetWeekCompletion;
        const screenshotMode = store.main.write.screenshotMode;
        const style = E({
            display: "inline-flex", backgroundColor: "rgba(90,100,110,.6)", borderRadius: 5, border: "1px solid rgba(210,210,230,.12)",
            color: "rgb(170,170,170)", fontSize: 14, cursor: "pointer", padding: "5px 10px", width: "100%",
            ":hover": { backgroundColor: "rgba(90,100,110,.8)" },
        }, selected && { backgroundColor: "rgba(90,100,110,.8)" });
        const firstIndexOutsideTargetWeekPeriod = orderedEvents.findIndex(a => a.week > targetWeekCompletion).IfN1Then(orderedEvents.length);
        const unorderedEvents_noPlaceholders = unorderedEvents.filter(a => a.placeholderCount == null);
        const placeholderCount = events.map(a => a.placeholderCount || 0).Sum();
        const orderedEvents_noPlaceholders = orderedEvents.filter(a => a.placeholderCount == null);
        const totalExpectedEventsCount = (unorderedEvents_noPlaceholders.length + placeholderCount + orderedEvents_noPlaceholders.length).KeepAtLeast(1);
        const placeholderCount_withinTargetPeriod = orderedEvents.slice(0, firstIndexOutsideTargetWeekPeriod).map(a => a.placeholderCount || 0).Sum();
        const orderedEvents_noPlaceholders_withinTargetPeriod = orderedEvents.slice(0, firstIndexOutsideTargetWeekPeriod).filter(a => a.placeholderCount == null);
        const totalExpectedEventsCount_withinTargetPeriod = placeholderCount_withinTargetPeriod + orderedEvents_noPlaceholders_withinTargetPeriod.length;
        return (React.createElement(Fragment, null,
            differentLevel
                && React.createElement(Row, null,
                    "Level: ",
                    character.level),
            React.createElement(Row, { onContextMenu: e => e.preventDefault() },
                React.createElement("div", { className: classnames(ClassBasedStyles(style), "focusTarget"), style: style, onClick: e => {
                        runInAction("CharEntryUI.selectChar", () => store.main.write.selectedCharacter = character._key);
                    } },
                    character.name,
                    screenshotMode || character.note == null || character.note.trim().length == 0 ? "" : ` (${character.note})`,
                    React.createElement(Pre, { ml: "auto" },
                        unorderedEvents_noPlaceholders.length,
                        "/",
                        placeholderCount,
                        "/",
                        orderedEvents_noPlaceholders.length,
                        " (",
                        totalExpectedEventsCount_withinTargetPeriod != 0
                            ? (orderedEvents_noPlaceholders_withinTargetPeriod.length / totalExpectedEventsCount_withinTargetPeriod).ToPercentStr(0)
                            : "100%",
                        ")")))));
    }
};
CharEntryUI = __decorate([
    Observer
], CharEntryUI);
let UnorderedEventColumn = class UnorderedEventColumn extends BaseComponentPlus({}, {}) {
    render() {
        const { bookID, character } = this.props;
        const unorderedEvents = GetUnorderedEvents(bookID, character._key);
        const orderedEvents = GetOrderedEvents(bookID, character._key);
        const selectedEvent = GetSelectedEvent();
        const droppableInfo = new DroppableInfo({ type: "UnorderedEventColumn", characterID: character._key });
        return (React.createElement(Column, { className: "clickThrough", ml: 10, style: { flex: 12.5, height: "100%", background: "rgba(0,0,0,.7)", borderRadius: 10 } },
            React.createElement(Row, { style: { height: 40, padding: 10 } },
                React.createElement(Pre, null, "Unordered"),
                React.createElement(Row, { ml: "auto" },
                    React.createElement(Button, { text: ">", title: "Move all unordered events to the ordered list.", onClick: () => {
                            ShowMessageBox({
                                title: `Move all unordered events`, cancelButton: true,
                                message: `
									This will move all the unordered events in the left column, to the bottom of the right column (as ordered events).
									
									Continue?
								`.AsMultiline(0),
                                onOK: () => {
                                    let nextIndex = orderedEvents.length;
                                    for (const event of unorderedEvents) {
                                        new SetBookEventIndex({ characterID: character._key, eventID: event._key, index: nextIndex }).Run();
                                        nextIndex++;
                                    }
                                },
                            });
                        } }),
                    React.createElement(Pre, { ml: 5 }, unorderedEvents.length))),
            React.createElement(AddEventBar, { bookID: bookID, character: character }),
            React.createElement(Droppable, { type: "BookEvent", droppableId: ToJSON(droppableInfo) }, (provided, snapshot) => (React.createElement(ScrollView, { ref: c => provided.innerRef(GetDOM(c)), style: { flex: 1 } },
                unorderedEvents.map((event, index) => {
                    const selected = selectedEvent == event;
                    return React.createElement(EventRow, { key: index, event: event, index: index, previousEvent: orderedEvents[index - 1], selected: selected, character: character });
                }),
                provided.placeholder)))));
    }
};
UnorderedEventColumn = __decorate([
    Observer
], UnorderedEventColumn);
export { UnorderedEventColumn };
let OrderedEventColumn = class OrderedEventColumn extends BaseComponentPlus({}, {}) {
    render() {
        const { bookID, character } = this.props;
        const orderedEvents = GetOrderedEvents(bookID, character._key, true);
        const eventIndexes = GetEventIndexes(character._key);
        const selectedEvent = GetSelectedEvent();
        const eventIndexes_byEvent = eventIndexes.Pairs().ToMap(a => a.value.toString(), a => a.keyNum);
        const droppableInfo = new DroppableInfo({ type: "OrderedEventColumn", characterID: character._key });
        return (React.createElement(Column, { className: "clickThrough", ml: 10, style: { flex: 25, height: "100%", background: "rgba(0,0,0,.7)", borderRadius: 10 } },
            React.createElement(Row, { style: { height: 40, padding: 10 } },
                React.createElement(Pre, null, "Ordered"),
                React.createElement(Pre, { ml: "auto" }, orderedEvents.length)),
            React.createElement(Droppable, { type: "BookEvent", droppableId: ToJSON(droppableInfo) }, (provided, snapshot) => (React.createElement(ScrollView, { ref: c => provided.innerRef(GetDOM(c)), style: { flex: 1 } },
                orderedEvents.map((event, index) => {
                    const selected = selectedEvent == event;
                    return React.createElement(EventRow, { key: index, event: event, index: index, previousEvent: orderedEvents[index - 1], selected: selected, character: character, orderIndex: eventIndexes_byEvent[event._key] });
                }),
                provided.placeholder)))));
    }
};
OrderedEventColumn = __decorate([
    Observer
], OrderedEventColumn);
export { OrderedEventColumn };
export class AddEventBar extends BaseComponent {
    render() {
        const { bookID, character, insertIndex, style, onAction } = this.props;
        return (React.createElement(Row, { style: style },
            React.createElement(Button, { text: "+", onClick: e => {
                    if (onAction)
                        onAction();
                    let newEvent_text = "";
                    const boxController = ShowMessageBox({
                        title: "Add event", cancelButton: true,
                        message: () => {
                            return (React.createElement(Column, { style: { padding: "10px 0", width: 600 } },
                                React.createElement(TextInput, { value: newEvent_text, onChange: val => {
                                        newEvent_text = val;
                                        boxController.UpdateUI();
                                    } })));
                        },
                        onOK: async () => {
                            const newEvent = new BookEvent({ book: bookID, text: newEvent_text, characters: { [character._key]: { _: true } } });
                            const eventID = await new AddBookEvent({ event: newEvent }).Run();
                            new SetBookEventIndex({ characterID: character._key, eventID, index: insertIndex }).Run();
                        },
                    });
                } }),
            React.createElement(Button, { text: "P1", style: { flex: .5, padding: "5px 0" }, onClick: async (e) => {
                    if (onAction)
                        onAction();
                    const newEvent = new BookEvent({ book: bookID, placeholderCount: 1, characters: { [character._key]: { _: true } } });
                    const eventID = await new AddBookEvent({ event: newEvent }).Run();
                    new SetBookEventIndex({ characterID: character._key, eventID, index: insertIndex }).Run();
                } }),
            React.createElement(Button, { text: "P3", style: { flex: 1, padding: "5px 0" }, onClick: async (e) => {
                    if (onAction)
                        onAction();
                    const newEvent = new BookEvent({ book: bookID, placeholderCount: 3, characters: { [character._key]: { _: true } } });
                    const eventID = await new AddBookEvent({ event: newEvent }).Run();
                    new SetBookEventIndex({ characterID: character._key, eventID, index: insertIndex }).Run();
                } }),
            React.createElement(Button, { text: "P5", style: { flex: 1, padding: "5px 0" }, onClick: async (e) => {
                    if (onAction)
                        onAction();
                    const newEvent = new BookEvent({ book: bookID, placeholderCount: 5, characters: { [character._key]: { _: true } } });
                    const eventID = await new AddBookEvent({ event: newEvent }).Run();
                    new SetBookEventIndex({ characterID: character._key, eventID, index: insertIndex }).Run();
                } }),
            React.createElement(Button, { text: "P10", style: { flex: 1, padding: "5px 0" }, onClick: async (e) => {
                    if (onAction)
                        onAction();
                    const newEvent = new BookEvent({ book: bookID, placeholderCount: 10, characters: { [character._key]: { _: true } } });
                    const eventID = await new AddBookEvent({ event: newEvent }).Run();
                    new SetBookEventIndex({ characterID: character._key, eventID, index: insertIndex }).Run();
                } })));
    }
}
